import React, { useEffect, useState, Fragment } from 'react';
const STORAGE_KEY = 'artepronta_offer_end';
const DURATION_MS = 24 * 60 * 60 * 1000; // 24h
function getOrCreateEndTime(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const t = parseInt(stored, 10);
      if (!isNaN(t) && t > Date.now()) return t;
    }
  } catch (e) {}
  const end = Date.now() + DURATION_MS;
  try {
    localStorage.setItem(STORAGE_KEY, String(end));
  } catch (e) {}
  return end;
}
function format(n: number) {
  return String(Math.max(0, n)).padStart(2, '0');
}
export function CountdownBanner() {
  const [endTime] = useState(() => getOrCreateEndTime());
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const remaining = Math.max(0, endTime - now);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return <div className="bg-gradient-to-r from-badge-red/20 via-orange-500/20 to-badge-red/20 border border-badge-red/40 rounded-2xl p-4 sm:p-5 mb-6 sm:mb-8 text-center" data-id="element-77">
      <p className="text-badge-red font-black text-xs sm:text-sm uppercase tracking-wider mb-2 flex items-center justify-center gap-2" data-id="element-78">
        <span className="w-2 h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-79"></span>
        ⏰ L'offerta scade tra:
      </p>
      <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="polite" data-id="element-80">
        {[{
        v: hours,
        l: 'ORE'
      }, {
        v: minutes,
        l: 'MIN'
      }, {
        v: seconds,
        l: 'SEC'
      }].map((u, i) => <Fragment key={u.l} data-id="element-81">
            <div className="bg-bg-dark border border-badge-red/30 rounded-lg px-3 py-2 sm:px-4 sm:py-2.5 min-w-[56px] sm:min-w-[72px]" data-id="element-82">
              <div className="text-text-main font-black text-xl sm:text-3xl tabular-nums leading-none" data-id="element-83">
                {format(u.v)}
              </div>
              <div className="text-text-sec text-[9px] sm:text-[10px] font-bold tracking-wider mt-1" data-id="element-84">
                {u.l}
              </div>
            </div>
            {i < 2 && <span className="text-badge-red font-black text-xl sm:text-2xl" data-id="element-85">
                :
              </span>}
          </Fragment>)}
      </div>
      <p className="text-text-sec text-xs sm:text-sm mt-3 font-medium" data-id="element-86">
        Dopo questo tempo il prezzo tornerà a{' '}
        <span className="text-text-main font-bold line-through" data-id="element-87">€ 290,00</span>
      </p>
    </div>;
}